import { Component, Input } from '@angular/core';
import { WeatherForecastIcons } from 'src/app/models/app-constants';

@Component({
	selector: 'app-weather-forecast',
	templateUrl: './weather-forecast.component.html',
	styleUrls: ['./weather-forecast.component.scss']
})
export class WeatherForecastComponent {
	@Input() forecast : string | undefined;
	@Input() foreCastIconCode : number | undefined;
	@Input() airtemp : number | undefined;
	@Input() uvAlert : string | undefined;
	@Input() uvOrOtherLabel : string = "UV:Alert";
	@Input() uvOrOtherValue : string  | undefined;

	getWeatherForecastIcon() : string {
		const icon = WeatherForecastIcons.get(this.foreCastIconCode ? Number(this.foreCastIconCode) : 0);
		
		return icon ?? "";
	}

	get airTemperature () {
		return null != this.airtemp && /^\d+$/.test(this.airtemp.toString()) ? this.airtemp!.toString() + '°C' : "";
	}

	
}
